module.exports = __webpack_public_path__ + "img/bg_landing2.e4cf2ad1.png";